import {QuestionSet} from "./question-set";
import {Question} from "./question";
import {QuestionSetLabel} from "./question-set-label";
import {Assessment} from "./assessment";

export class DisplayCondition {

    /**
     * Whether the condition should hide or show the question set.
     */
    private _displayType: "show" | "hide";

    /**
     * The question set that the display condition belongs to.
     */
    private _questionSet:QuestionSet;

    /**
     * The id of the question this condtion belongs to
     */
    private _question:Question;

    /**
     * The question set label answer that must be selected in
     * order for the display condition to trigger.
     */
    private _answer:QuestionSetLabel;

    get displayType() {
        return this._displayType;
    }

    set displayType(v:"show" | "hide") {
        this._displayType = v;
    }

    get questionSet() {
        return this._questionSet;
    }

    set questionSet(v:QuestionSet) {
        this._questionSet = v;
    }

     get question() {
        return this._question;
    }

    set question(v:Question) {
        this._question = v;
    }

     get answer() {
        return this._answer;
    }

    set answer(v:QuestionSetLabel) {
        this._answer = v;
    }

    public getDisplay(assessment:Assessment) {
        if (this._displayType === 'show') {
            if (this.shouldShow(assessment)) {
                return 'show';
            }
            return 'hide';
        }
        else if (this.shouldHide(assessment)) {
            return 'hide';
        }
        return 'show';
    }

    public shouldShow(assessment:Assessment) {
        return this.metAnswerCondition('show', assessment);
    }

    public shouldHide(assessment:Assessment) {
        return this.metAnswerCondition('hide', assessment);
    }

    private metAnswerCondition(type:string, assessment:Assessment) {
         if (this._displayType !== type) {
            return false;
        }

        let qs = assessment.getQuestionSetById(this.questionSet.id);
        if (!qs) {
            return false;
        }

        let q = qs.getQuestionById(this.question.id);
        if (!q) {
            return false;
        }
        if (q.hasAnswer(this.answer)){
        // if (q.answer && q.answer.id && q.answer.id == this.answer.id) {
            return true;
        }
        return false;
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/models/display-condition.ts